// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__Sz9li","spinner":"SmallLoader_spinner__Vd9By","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__n2LGI"};